import { c as _c } from "react/compiler-runtime";
import './gift-info-table.scss';
import { EditorViewer } from '@common/components/organism/EditorViewer';
import { cn } from '@core/utils';
import { TABS } from '../../../constants';
interface GiftTabContentInfoProps {
  productInfo: string;
}
export const GiftTabContentInfo = t0 => {
  const $ = _c(4);
  const {
    productInfo
  } = t0;
  const hasImage = /<img[\s>]/i.test(productInfo);
  const hasText = Boolean(productInfo.replace(/<[^>]*>|&nbsp;/gi, "").trim());
  if (!hasImage && !hasText) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex flex-col gap-12 *:px-0", "mobile-tablet:gap-12 mobile-tablet:px-20");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className={cn("pb-16 pt-32 font-600 text-Gray-900 typo-h5", "mobile-tablet:pb-8 mobile-tablet:pt-16 mobile-tablet:typo-body1")}>답례품 기본 정보</h2>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== productInfo) {
    t3 = <section className={t1} id={TABS.INFO}>{t2}<EditorViewer content={productInfo} className="gift-info-table" /></section>;
    $[2] = productInfo;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};